import React from "react";
import { Spinner } from "reactstrap";

const PageLoader = ({ title = "" }) => {
  return (
    <div className="page-content">
      <div className=" text-center p-4">
        <Spinner />
        {title && <p className="py-2">{title}</p>}
      </div>
    </div>
  );
};

export default PageLoader;
